"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _StepWrapper = _interopRequireDefault(require("../StepWrapper"));
var _StepAvatar = _interopRequireDefault(require("../StepAvatar"));
var _StepContent = _interopRequireDefault(require("../StepContent"));
var _StepLabel = _interopRequireDefault(require("../StepLabel"));
var _messages = _interopRequireDefault(require("./messages"));
var _excluded = ["label", "children", "isStatic", "isFirst", "isLast", "light", "noInitialConnector", "noEndConnector", "completed", "active", "isDisabled", "intl"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "descritiveText": "XD6osz"
};
var Step = function Step(_ref) {
  var label = _ref.label,
    children = _ref.children,
    isStatic = _ref.isStatic,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    light = _ref.light,
    noInitialConnector = _ref.noInitialConnector,
    noEndConnector = _ref.noEndConnector,
    completed = _ref.completed,
    active = _ref.active,
    isDisabled = _ref.isDisabled,
    intl = _ref.intl,
    props = _objectWithoutProperties(_ref, _excluded);
  var labelIsString = typeof label === 'string';
  var getLabelSuffix = function getLabelSuffix() {
    var suffix = intl.formatMessage(_messages["default"].incompletedStepSuffix, {
      label: label
    });
    if (completed) {
      suffix = intl.formatMessage(_messages["default"].completedStepSuffix, {
        label: label
      });
    } else if (active) {
      suffix = intl.formatMessage(_messages["default"].currentStepSuffix, {
        label: label
      });
    }
    return suffix;
  };
  var labelIdentifier = labelIsString ? label.split(' ').join('') : '';
  return /*#__PURE__*/_react["default"].createElement(_StepWrapper["default"], _extends({}, props, {
    completed: completed,
    active: active,
    disabled: isDisabled,
    isStatic: isStatic,
    light: light
  }), labelIsString && /*#__PURE__*/_react["default"].createElement("span", {
    id: "".concat(labelIdentifier, "-label"),
    className: styles.descritiveText
  }, getLabelSuffix()), /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], {
    isStatic: isStatic,
    light: light,
    disabled: isDisabled,
    StepIconComponent: _StepAvatar["default"],
    "aria-hidden": labelIsString,
    "aria-labelledby": labelIsString ? "".concat(labelIdentifier, "-label") : '',
    StepIconProps: {
      isFirst: isFirst,
      isLast: isLast,
      isStatic: isStatic,
      light: light,
      noInitialConnector: noInitialConnector,
      noEndConnector: noEndConnector
    }
  }, label), children && (props.orientation === 'vertical' ? /*#__PURE__*/_react["default"].createElement(_StepContent["default"], {
    isStatic: isStatic,
    orientation: props.orientation,
    completed: completed,
    active: active,
    disabled: isDisabled
  }, children) : children));
};
Step.propTypes = process.env.NODE_ENV !== "production" ? {
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  children: _propTypes["default"].node,
  light: _propTypes["default"].bool,
  isFirst: _propTypes["default"].bool,
  isLast: _propTypes["default"].bool,
  isStatic: _propTypes["default"].bool,
  noInitialConnector: _propTypes["default"].bool,
  noEndConnector: _propTypes["default"].bool,
  completed: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  intl: _propTypes["default"].object.isRequired,
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical'])
} : {};
var _default = exports["default"] = (0, _reactIntl.injectIntl)(Step);